module.exports = __webpack_public_path__ + "static/media/no_friends.f2b969a2.png";